import { CourseEnum, ModuleCourse } from './course-general'

export const instructors = [
  {
    id: 1,
    username: 'Quân Đặng',
    position: 'Founder & CEO',
    description: 'Senior Data Scientist tại Yokogawa Singapore với hơn 8 năm kinh nghiệm trong ngành.',
    avatar: '/images/founder.webp',
    transform: 'translateY(14px) scale(1.3)',
    linkedin: 'https://www.linkedin.com/in/quan-dang/',
    course: CourseEnum.MLOps,
    module: `${ModuleCourse.AIDE} & ${ModuleCourse.DSAA}`,
    experience: 8,
    status: 'active',
  },
  {
    id: 2,
    username: 'Quý Đinh',
    position: 'Senior Machine Learning Engineer',
    description: 'Senior Machine Learning Engineer tại Grab Singapore với hơn 7 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/quy-dinh.jpeg',
    experience: 7,
    company: 'Grab Singapore',
    transform: '',
    course: CourseEnum.RECOMMENDER_SYSTEM,
    module: ModuleCourse.DSAA,
    linkedin: 'https://sg.linkedin.com/in/dvquy',
    status: 'deprecated',
  },
  {
    id: 3,
    username: 'Đức Lương',
    position: 'Machine Learning Tech Lead',
    description: 'Machine Learning Tech Lead tại GeoComply với hơn 7 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/duc-luong.jpg',
    company: 'GeoComply',
    transform: 'translateY(14px) scale(1.3)',
    experience: 7,
    course: CourseEnum.DATA_ENGINEERING,
    module: ModuleCourse.AIDE,
    linkedin: 'https://www.linkedin.com/in/max-luong',
    status: 'active',
  },
  {
    id: 4,
    username: 'Tú Trần',
    position: 'Research Scientist',
    description: 'Research Scientist tại Knorex với hơn 5 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/tu-tran.jpg',
    company: 'Knorex',
    transform: 'translateY(14px) scale(1.6)',
    experience: 5,
    course: CourseEnum.NATURAL_LANGUAGE_PROCESSING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/tu-tran-3748a1287/',
    status: 'deprecated',
  },
  {
    id: 5,
    username: 'Hoàng Phạm',
    position: 'Head of AI & Lecturer',
    description: 'Head of AI OLLI Technology & Lecturer ĐH KHTN TPHCM với hơn 13 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/hoang-pham.jpg',
    company: 'OLLI Technology',
    transform: 'translateY(14px) scale(1.3)',
    experience: 13,
    course: CourseEnum.COMPUTER_VISION,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/hoang-pham-minh-b4746640/',
    status: 'deprecated',
  },
  {
    id: 6,
    username: 'Thạch Lê',
    position: 'Data Science Manager',
    description: 'Data Science Manager tại MoMo với hơn 10 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/thach-le.png',
    company: 'MoMo',
    transform: 'translateY(10px) scale(1.2)',
    experience: 10,
    course: CourseEnum.LLM,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/ngocthach1207/',
    status: 'deprecated',
  },
  {
    id: 7,
    username: 'Quan Huỳnh',
    position: 'Data Science Manager',
    description: 'Data Science Manager tại HCLTech với hơn 8 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/quan-huynh.jpeg',
    company: 'HCLTech',
    transform: 'translateY(14px) scale(1.3)',
    experience: 8,
    course: CourseEnum.MACHINE_LEARNING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/charles-huynh/',
    status: 'deprecated',
  },
  {
    id: 8,
    username: 'Huy Nguyễn',
    position: 'Analytics Engineer Manager',
    description: 'Analytics Engineer Manager tại ZITGA STUDIO với hơn 6 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/huy-data.jpeg',
    company: 'ZITGA STUDIO',
    transform: 'translateY(14px) scale(1.3)',
    experience: 6,
    course: CourseEnum.BUSINESS_INTELLIGENCE,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/nguyen-tien-huy-8b0934212/',
    status: 'deprecated',
  },
  {
    id: 9,
    username: 'Nguyên Phạm',
    position: 'Senior MLOps Engineer',
    description: 'Senior MLOps Engineer tại MoMo với hơn 5 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/nguyen-pham.jpg',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.2)',
    experience: 5,
    course: CourseEnum.MLOps,
    module: ModuleCourse.AIDE,
    linkedin: 'https://www.linkedin.com/in/nguyen-pham-877a531a9/',
    status: 'active',
  },
  {
    id: 10,
    username: 'Đức Nguyễn',
    position: 'Senior Data Scientist',
    description: 'Senior Data Scientist tại Mobifone IT Center với hơn 5 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/duc-nguyen.jpg',
    company: 'Mobifone IT Center',
    transform: 'translateY(10px) scale(1.2)',
    experience: 5,
    course: CourseEnum.SPEECH,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/sy-duc-nguyen-433a12235/',
    status: 'deprecated',
  },
  {
    id: 11,
    username: 'Quan Huỳnh',
    position: 'Data Science Manager',
    description: 'Data Science Manager tại HCLTech với hơn 8 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/quan-huynh.jpeg',
    company: 'HCLTech',
    transform: 'translateY(14px) scale(1.3)',
    experience: 8,
    course: CourseEnum.DEEP_LEARNING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/charles-huynh/',
    status: 'deprecated',
  },
  {
    id: 12,
    username: 'Tiến Nguyễn',
    position: 'Machine Learning Engineer',
    description: 'Machine Learning Engineer tại MoMo với hơn 3 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/tien_nguyen.jpeg',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.3)',
    experience: 3,
    course: CourseEnum.FUNDAMENTALS_OF_SOFTWARE_ENGINEERING,
    module: ModuleCourse.FSWE,
    linkedin: 'https://www.linkedin.com/in/tien-nk/',
    status: 'active',
  },
  {
    id: 13,
    username: 'Hoàng Anh',
    position: 'Software Engineer',
    description: 'Software Engineer tại FSDS với hơn 3 năm kinh nghiệm trong ngành.',
    avatar: '/images/instructors/hoangang.jpg',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.3)',
    experience: 3,
    course: CourseEnum.SOFTWARE_ENGINEERING,
    module: ModuleCourse.BAIW,
    linkedin: '#',
    status: 'active',
  },
]

export const nonFSDSInstructors = [
  {
    id: 1,
    username: 'Quân Đặng',
    position: 'Founder & CEO',
    description: 'Senior Data Scientist tại Yokogawa Singapore với hơn 8 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    transform: 'translateY(14px) scale(1.3)',
    linkedin: 'https://www.linkedin.com/in/quan-dang/',
    course: CourseEnum.MLOps,
    module: `${ModuleCourse.AIDE} & ${ModuleCourse.DSAA}`,
    experience: 8,
    status: 'active',
  },
  {
    id: 2,
    username: 'Quý Đinh',
    position: 'Senior Machine Learning Engineer',
    description: 'Senior Machine Learning Engineer tại Grab Singapore với hơn 7 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    experience: 7,
    company: 'Grab Singapore',
    transform: '',
    course: CourseEnum.RECOMMENDER_SYSTEM,
    module: ModuleCourse.DSAA,
    linkedin: 'https://sg.linkedin.com/in/dvquy',
    status: 'active',
  },
  {
    id: 3,
    username: 'Đức Lương',
    position: 'Machine Learning Tech Lead',
    description: 'Machine Learning Tech Lead tại GeoComply với hơn 7 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'GeoComply',
    transform: 'translateY(14px) scale(1.3)',
    experience: 7,
    course: CourseEnum.DATA_ENGINEERING,
    module: ModuleCourse.AIDE,
    linkedin: 'https://www.linkedin.com/in/max-luong',
    status: 'active',
  },
  {
    id: 4,
    username: 'Tú Trần',
    position: 'Research Scientist',
    description: 'Research Scientist tại Knorex với hơn 5 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'Knorex',
    transform: 'translateY(14px) scale(1.6)',
    experience: 5,
    course: CourseEnum.NATURAL_LANGUAGE_PROCESSING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/tu-tran-3748a1287/',
    status: 'active',
  },
  {
    id: 5,
    username: 'Hoàng Phạm',
    position: 'Head of AI & Lecturer',
    description: 'Head of AI OLLI Technology & Lecturer ĐH KHTN TPHCM với hơn 13 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'OLLI Technology',
    transform: 'translateY(14px) scale(1.3)',
    experience: 13,
    course: CourseEnum.COMPUTER_VISION,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/hoang-pham-minh-b4746640/',
    status: 'deprecated',
  },
  {
    id: 6,
    username: 'Thạch Lê',
    position: 'Data Science Manager',
    description: 'Data Science Manager tại MoMo với hơn 10 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'MoMo',
    transform: 'translateY(10px) scale(1.2)',
    experience: 10,
    course: CourseEnum.LLM,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/ngocthach1207/',
    status: 'deprecated',
  },
  {
    id: 7,
    username: 'Quan Huỳnh',
    position: 'Data Science Manager',
    description: 'Data Science Manager tại HCLTech với hơn 8 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'HCLTech',
    transform: 'translateY(14px) scale(1.3)',
    experience: 8,
    course: CourseEnum.MACHINE_LEARNING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/charles-huynh/',
    status: 'deprecated',
  },
  {
    id: 8,
    username: 'Huy Nguyễn',
    position: 'Analytics Engineer Manager',
    description: 'Analytics Engineer Manager tại ZITGA STUDIO với hơn 6 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'ZITGA STUDIO',
    transform: 'translateY(14px) scale(1.3)',
    experience: 6,
    course: CourseEnum.BUSINESS_INTELLIGENCE,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/nguyen-tien-huy-8b0934212/',
    status: 'deprecated',
  },
  {
    id: 9,
    username: 'Nguyên Phạm',
    position: 'Senior MLOps Engineer',
    description: 'Senior MLOps Engineer tại MoMo với hơn 5 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.2)',
    experience: 5,
    course: CourseEnum.MLOps,
    module: ModuleCourse.AIDE,
    linkedin: 'https://www.linkedin.com/in/nguyen-pham-877a531a9/',
    status: 'active',
  },
  {
    id: 10,
    username: 'Đức Nguyễn',
    position: 'Senior Data Scientist',
    description: 'Senior Data Scientist tại Mobifone IT Center với hơn 5 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'Mobifone IT Center',
    transform: 'translateY(10px) scale(1.2)',
    experience: 5,
    course: CourseEnum.SPEECH,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/sy-duc-nguyen-433a12235/',
    status: 'deprecated',
  },
  {
    id: 11,
    username: 'Quan Huỳnh',
    position: 'Data Science Manager',
    description: 'Data Science Manager tại HCLTech với hơn 8 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'HCLTech',
    transform: 'translateY(14px) scale(1.3)',
    experience: 8,
    course: CourseEnum.DEEP_LEARNING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/charles-huynh/',
    status: 'deprecated',
  },
  {
    id: 12,
    username: 'Tiến Nguyễn',
    position: 'Machine Learning Engineer',
    description: 'Machine Learning Engineer tại MoMo với hơn 3 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.3)',
    experience: 3,
    course: CourseEnum.FUNDAMENTALS_OF_SOFTWARE_ENGINEERING,
    module: ModuleCourse.FSWE,
    linkedin: 'https://www.linkedin.com/in/tien-nk/',
    status: 'active',
  },
  {
    id: 13,
    username: 'Hoàng Anh',
    position: 'Software Engineer',
    description: 'Software Engineer tại FSDS với hơn 3 năm kinh nghiệm trong ngành.',
    avatar: '/images/avatar.png',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.3)',
    experience: 3,
    course: CourseEnum.SOFTWARE_ENGINEERING,
    module: ModuleCourse.BAIW,
    linkedin: '#',
    status: 'active',
  },
]

export type InstructorType = (typeof instructors)[number]
